export default __webpack_public_path__ + "static/media/PowellCatLocation-09.cd17afa5.jpg";